import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';

const HradminAddClaimValidationSchema = Yup.object().shape({
    typeOfClaim: Yup.string().required().oneOf(['Inpatient Claim','Outpatient Claim']),
    providerName: Yup.string().required(),
    amount: Yup.number()
        .required('Amount is required')
        .positive('Amount must be more than zero')
        .max(999999, 'Amount cannot be more than $999,999')
        .round(),
    currency: Yup.string()
        .required('Currency is required.'),

    admissionDate: Yup.date()
        .when('typeOfClaim', {
            is: 'Inpatient Claim',
            then: Yup.date().required('Admission Date is required.'),
            otherwise: Yup.date()
        }),
    dischargeDate: Yup.date()
        .when('typeOfClaim', {
            is: 'Inpatient Claim',
            then: Yup.date().required('Discharge Date is required.'),
            otherwise: Yup.date()
        }),

    visitDate: Yup.date()
        .when('typeOfClaim', {
            is: 'Outpatient Claim',
            then: Yup.date().required('Visit Date is required.'),
            otherwise: Yup.date()
        }),
    receiptNo: Yup.string()
        .when('typeOfClaim', {
            is: 'Outpatient Claim',
            then: Yup.string().required('Receipt No is required.'),
            otherwise: Yup.string()
        }),
    prePostHospitalisation: Yup.string()
        .when('typeOfClaim', {
            is: 'Outpatient Claim',
            then: Yup.string().required().uppercase().oneOf(['Y','N']),
            otherwise: Yup.string()
        }),
});

export default HradminAddClaimValidationSchema;